import { CreateCollaborateurPage } from "@features/rh/collaborateurs/components/CreateCollaborateurPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { UserPlus } from "lucide-react";

export const Route = createFileRoute("/_app/rh/collaborateurs/create")({
  loader: requirePermission(PERMISSIONS.RH.PERSONNE.CREATE),
  staticData: {
    title: "Ajouter un collaborateur",
    icon: UserPlus,
    permission: PERMISSIONS.RH.PERSONNE.CREATE,
    section: "App",
    showInBreadcrumb: true,
  },
  component: CreateCollaborateurPage,
});
